
const Logo = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width={"250"}
            viewBox="0 0 248.23 64.16" {...props}>
            <g data-name="Capa 2">
                <g data-name="Capa 1">
                    <path
                        fill="#9dd2c4"
                        stroke="#1d1d1b"
                        strokeMiterlimit={10}
                        d="M7.94 24.17h28.93v6.01H13.8l.04 20.32 23.03.19v5.97H7.75l.19-32.49z"
                    />
                    <path
                        fill="#9dd2c4"
                        stroke="#1d1d1b"
                        strokeMiterlimit={10}
                        d="M.5 18.76 32.25.58l17.22 9.96V5.58l5.85.08v8.18l8.22 4.69v6.78l-8.29-4.76.19 36.4h-6.13V42.76H30.2v6.48l-6.01.03.12-17.4 5.85.04-.04 5.07 19.23.04.08-19.81-17.25-9.85L.5 25.59v-6.83z"
                    />
                    <path
                        fill="#9dd2c4"
                        stroke="#1d1d1b"
                        strokeMiterlimit={10}
                        d="M27.34 18.15h4.13v4.1h-4.13zM32.58 12.79h4.13v4.1h-4.13zM32.58 18.15h4.13v4.1h-4.13zM27.34 12.79h4.13v4.1h-4.13z"
                    />
                    <text
                        transform="translate(68.16 56.95)"
                        fontSize={33.04}
                        fill="#00b2bf"
                        fontFamily="BerlinSansFB-Reg, Berlin Sans FB"
                        letterSpacing="-.01em"
                        style={{
                            isolation: "isolate",
                        }}
                    >
                        {"Aberturas"}
                    </text>
                    <text
                        transform="translate(68.16 56.95)"
                        fontSize={33.04}
                        fill="none"
                        stroke="#000"
                        strokeMiterlimit={10}
                        fontFamily="BerlinSansFB-Reg, Berlin Sans FB"
                        letterSpacing="-.01em"
                        style={{
                            isolation: "isolate",
                        }}
                    >
                        {"Aberturas"}
                    </text>
                    <text
                        transform="translate(205.15 56.66)"
                        fontSize={33.04}
                        fill="#9dd2c4"
                        fontFamily="BerlinSansFB-Reg, Berlin Sans FB"
                        letterSpacing="-.01em"
                        style={{
                            isolation: "isolate",
                        }}
                    >
                        {"CH"}
                    </text>
                    <text
                        transform="translate(205.15 56.66)"
                        fontSize={33.04}
                        fill="none"
                        stroke="#1d1d1b"
                        strokeMiterlimit={10}
                        fontFamily="BerlinSansFB-Reg, Berlin Sans FB"
                        letterSpacing="-.01em"
                        style={{
                            isolation: "isolate",
                        }}
                    >
                        {"CH"}
                    </text>
                </g>
            </g>
        </svg>

    );
}

export default Logo;